import { render, staticRenderFns } from "./CreateBaseDistance.vue?vue&type=template&id=685cd0d0&scoped=true"
import script from "./CreateBaseDistance.vue?vue&type=script&lang=js"
export * from "./CreateBaseDistance.vue?vue&type=script&lang=js"
import style0 from "./CreateBaseDistance.vue?vue&type=style&index=0&id=685cd0d0&prod&lang=css"
import style1 from "./CreateBaseDistance.vue?vue&type=style&index=1&id=685cd0d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685cd0d0",
  null
  
)

export default component.exports